/* eslint-disable @typescript-eslint/no-explicit-any */
import { BusinessHours } from '../../types/business-hours';

export interface BusinessHoursForm {}
export interface QueueSettingsForm {
  name: string;
  ticketPrefix: string;
}

export interface QueueSettingsState {
  dirty: boolean;
  businessHoursForm: BusinessHoursForm | null;
  settingsForm: QueueSettingsForm | null;
  settingsDirty: boolean;
}

export const BASE_SETTINGS_CHANGED = 'queueSettings/BASE_SETTINGS_CHANGED';
export const BUSINESS_HOURS_CHANGED = 'queueSettings/BUSINESS_HOURS_CHANGED';
export const SAVE_QUEUE_SETTINGS_SAGA = 'queueSettings/SAVE_QUEUE_SETTINGS_SAGA';
export const CLEAR_QUEUE_SETTINGS_FORM = 'queueSettings/CLEAR_QUEUE_SETTINGS_FORM';

export const WS_REQUEST_SAGA = 'queues/ws-request-saga';

export const RESET_QUEUE_REQUEST = 'booth-queue-reset';
export const CHANGE_QUEUE_STATE_REQUEST = 'booth/change-queue-state';

export function saveQueueSettingsSaga(payload: {
  queueId: string;
  baseSettings?: QueueSettingsForm;
  businessHours?: BusinessHours;
}) {
  return { type: SAVE_QUEUE_SETTINGS_SAGA, payload };
}

export function sendQueueAction(queueId: string, actionName: string) {
  if (actionName === 'clearTickets') {
    return { type: WS_REQUEST_SAGA, cmd: RESET_QUEUE_REQUEST, queueId };
  } else if (actionName === 'reset') {
    return {
      type: WS_REQUEST_SAGA,
      cmd: RESET_QUEUE_REQUEST,
      resetTicketCounter: true,
      queueId
    };
  }
  return {
    type: WS_REQUEST_SAGA,
    cmd: CHANGE_QUEUE_STATE_REQUEST,
    actionName,
    queueId
  };
}
